/**
 * @ngdoc controller
 * @name RootController
 * @description
 * This component renders the main page.
 *
 * @memberof rootModule
 */
class RootController {
  /**
   * Class constructor
   * @param {Service} $location    To redirect the user when the app needs to be updated.
   * @param {Service} appUpdates   To listen for changes that require the app to be updated.
   * @param {Service} ccaSession   To get the active section.
   * @ignore
   */
  constructor(
    $location,
    appUpdates,
    ccaSession,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `appUpdates` service.
     * @type {Object}
     */
    this.appUpdates = appUpdates;
    /**
     * The local reference to the `ccaSession` service.
     * @type {Object}
     *
     */
    this.ccaSession = ccaSession;
  }
  /**
   * Initialize variables
   */
  $onInit() {
    // When the app needs to be updated, load the logout route.
    this.appUpdates.onNewUpdate(() => {
      this.$location.url('/logout?updated=true');
    });
  }
}

export default RootController;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/root/root.controller.js